import React, { Component } from "react";

import Paper from "@material-ui/core/Paper";
import AutoSizeInput from "../../components/AutoSizeInput/AutoSizeInput";
import ImageUploader from "../ImageUploader/ImageUploader";
import UploadButton from "../../components/ReactImageUpload/UploadImageButton";
import Dropdown from "../../components/Dropdown/Select";

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titulo: "",
      info: "",
      link: "",
      type: "Turismo",
      classes: {
        root: {
          padding: "3px 2px",
          display: "inline-grid",
          margin: "0 auto"
        },
        title: {
          textAlign: "center"
        },
        titleInput: {
          height: "100px"
        },
        textInput: {
          height: "300px"
        },
        inputContainer: {
          display: "inline-grid"
        }
      }
    };
  }

  handleUploadImage(imageToUpload, onHandleUploadImage) {
    const formData = new FormData();
    formData.append("myImage", imageToUpload.image);
    if (imageToUpload.image != null) {
      const config = {
        headers: {
          "content-type": "multipart/form-data"
        }
      };

      let newEvent = {
        type: this.state.type,
        titulo: this.state.titulo,
        info: this.state.info,
        link: this.state.link,
        imageUrl: ""
      };
      onHandleUploadImage(formData, config, newEvent);
    } else {
      alert("No te olvides de cargar tu factura");
    }
  }

  handleChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  handleChangeTypeDropdown = label => {
    this.setState({ type: label });
  };

  render() {
    let commonForm =
      this.state.type !== "Visitas Guiadas" ? (
        <div style={this.state.classes.inputContainer}>
          <AutoSizeInput
            onChange={this.handleChange}
            rows={1}
            label="Título"
            name="titulo"
          />
          <AutoSizeInput
            name="info"
            onChange={this.handleChange}
            rows={4}
            label="Texto informativo"
          />
          <AutoSizeInput
            name="link"
            onChange={this.handleChange}
            rows={1}
            label="Link de la información"
          />
        </div>
      ) : (<div>
        <AutoSizeInput
          onChange={this.handleChange}
          rows={1}
          label="Título"
          name="titulo"
        />
        <AutoSizeInput
          name="info"
          onChange={this.handleChange}
          rows={4}
          label="Días"
        />
        <AutoSizeInput
          name="link"
          onChange={this.handleChange}
          rows={1}
          label="Contacto"
        />
      </div>);
    return (
      <div>
        <Paper style={this.state.classes.root}>
          <h1 style={this.state.classes.title}>{this.props.element}</h1>
          <Dropdown
            label={"Tipo"}
            initialType={this.props.types[0].type}
            types={this.props.types}
            onHandleChange={this.handleChangeTypeDropdown}
          />
          {commonForm}
          <ImageUploader defaultImage={""} fieldValues={this.props.fieldValues} />
          <UploadButton
            onClick={() =>
              this.handleUploadImage(
                this.props.fieldValues,
                this.props.onUploadImage
              )
            }
          >
            Crear evento
          </UploadButton>
        </Paper>
      </div>
    );
  }
}

export default Form;
